import React from 'react';
import {
    Grid
} from 'semantic-ui-react';

const Footer = ({ operatorName }) => {
    return (
        <div className="InfoFooter">
            <Grid>
                <Grid.Row centered>
                    <Grid.Column>
                        Inloggad operatör: {operatorName}
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        </div>
    );
}

export default Footer;